function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.0005,
  cy: 25,
  r: 25,
  fill: "#E6EEFC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9296 24L35.5492 24.1394C35.8073 26.2738 35.2545 28.4556 33.9926 30.283C32.7132 32.1357 30.7543 33.54 28.4767 34.2372C27.3864 34.571 26.2663 34.7309 25.1569 34.7308C21.9546 34.7307 18.8468 33.3974 16.8384 31.0672H18.2135V29.7979H14.5V33.3482H15.8889V32.0112C17.2133 33.485 18.9684 34.6342 20.9612 35.3122C22.3077 35.7703 23.7282 36 25.1469 36C26.4238 36 27.6993 35.8139 28.9178 35.4409C31.498 34.651 33.7173 33.0598 35.167 30.9605C36.5962 28.8909 37.2222 26.419 36.9296 24V24Z",
  fill: "#0D5AE5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9894 18.4116C17.2821 16.322 19.279 14.7406 21.6123 13.9586C23.8845 13.1972 26.2748 13.2213 28.5251 14.0288C30.2823 14.6593 31.8489 15.7539 33.0439 17.1681L31.7065 17.1676L31.706 18.5717L35.5 18.573V14.8214H34.0966V16.2397C32.7452 14.6489 30.9788 13.4175 28.9988 12.7071C26.4491 11.7922 23.7407 11.7646 21.1666 12.6272C18.5233 13.5131 16.2609 15.3049 14.7961 17.6726C13.3504 20.0095 12.747 22.7894 13.0971 25.5L14.4889 25.3201C14.18 22.9284 14.7129 20.475 15.9894 18.4116Z",
  fill: "#0D5AE5"
});

var SvgExchangeIconPopUp = function SvgExchangeIconPopUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExchangeIconPopUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Exchange_icon_pop_up.03b144ba.svg";
export { ForwardRef as ReactComponent };